export const parseCurrencyValue = (
  value: string | number | null | undefined,
): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;
  if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;

  const raw = String(value).trim();
  if (!raw) return undefined;

  const digitsOnly = raw.replace(/[^\d,.-]/g, '');
  if (!digitsOnly) return undefined;

  const normalized = digitsOnly.includes(',')
    ? digitsOnly.replace(/\./g, '').replace(',', '.')
    : digitsOnly;

  const num = Number(normalized);
  return Number.isFinite(num) ? num : undefined;
};

export const formatCurrencyBRL = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return '';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const stringToCurrencyNumber = (value: string | undefined): number => {
  return parseCurrencyValue(value) ?? 0;
};

export const currencyNumberToString = (value: number | undefined): string => {
  if (value === undefined || Number.isNaN(value)) return '';
  return String(value);
};

export const parsePercentValue = parseCurrencyValue;

export const formatPercentBRL = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return '';
  return `${value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
};

export const stringToPercentNumber = (value: string | undefined): number => {
  return parsePercentValue(value) ?? 0;
};

export const percentNumberToString = currencyNumberToString;

export const formatCalendarDateBR = (value: string | null | undefined): string => {
  if (!value) return '—';
  const datePart = value.trim().slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) return '—';
  return `${match[3]}/${match[2]}/${match[1]}`;
};

export const formatDateTimeBR = (value: string | null | undefined): string => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('pt-BR');
};
